import React from 'react';

import {useStore} from 'effector-react';
import {useTranslation} from 'react-i18next';
import {useParams} from 'react-router-dom';

import {BackTo} from 'components/common/BackTo';
import {Page} from 'components/common/Page';
import {NoAccess} from 'components/pages/NoAccess';
import {ContentContainer} from 'components/ui-kit/PageComponents';
import {ROUTE} from 'core/routes';
import {FactoryLineGate, factoryLineState$} from 'models/profile/factories/factoryLineDetails';
import {breakpoint} from 'theme';
import {UserPermission} from 'types';
import {useMatchMedia, usePermission} from 'utils/custom-hooks';
import {formatDate} from 'utils/date';
import {formatNumber} from 'utils/number';

import {ReleasedChart} from './ReleasedChart';
import {
    ActivityContainer,
    ActivityContent,
    ActivityContentItem,
    ActivityTitle,
    ContentWrapper,
    FactoryName,
    Header,
    InfoContainer,
    InfoItem,
    InfoItemTitle,
    InfoItemValue,
    LineStatusTag,
    LineTitle,
    StatisticsContainer,
    FactoryTitle,
    LineName,
    LineCode,
    CustomBackTo,
} from './styled';

interface Params {
    factoryId: string;
    lineId: string;
}

export const FactoryLine = () => {
    const {t} = useTranslation();
    const {factoryId, lineId}: Params = useParams();
    const isMobile = useMatchMedia(`(max-width: ${breakpoint.phone})`);

    const {line, lineLoading, factory} = useStore(factoryLineState$);

    const activeLabel =
        line?.active || false
            ? t('pages.profile.equipment.active')
            : t('pages.profile.equipment.notActive');

    return <NoAccess />;

    // return (
    //     <Page title={t('pages.profile.title')}>
    //         <FactoryLineGate factoryId={factoryId} lineId={lineId} />
    //         <BackTo to={ROUTE.FACTORIES}>{t('pages.profile.equipment.back')}</BackTo>
    //         <ContentContainer status={lineLoading ? 'loading' : 'default'}>
    //             {line && (
    //                 <ContentWrapper>
    //                     <StatisticsContainer>
    //                         {factory && (
    //                             <FactoryName>
    //                                 <FactoryTitle>{factory.name}</FactoryTitle>
    //                             </FactoryName>
    //                         )}
    //                         <Header>
    //                             {!isMobile && (
    //                                 <CustomBackTo to={`${ROUTE.FACTORIES}/${factoryId}`}>
    //                                     {t('pages.profile.common.back')}
    //                                 </CustomBackTo>
    //                             )}
    //                             <LineTitle>
    //                                 <LineCode>{line.code.toUpperCase()}</LineCode>
    //                                 <LineName>{line.name.toUpperCase()}</LineName>
    //                                 <LineStatusTag isActive={line.active}>
    //                                     {activeLabel}
    //                                 </LineStatusTag>
    //                             </LineTitle>
    //                         </Header>
    //                         <ReleasedChart />
    //                         <InfoContainer>
    //                             <InfoItem>
    //                                 <InfoItemTitle>
    //                                     {t('pages.profile.equipment.lastActivity')}
    //                                 </InfoItemTitle>
    //                                 <InfoItemValue>
    //                                     {formatDate(line.lastActivityTime)}
    //                                 </InfoItemValue>
    //                             </InfoItem>
    //                             <InfoItem>
    //                                 <InfoItemTitle>
    //                                     {t('pages.profile.equipment.codes')}
    //                                 </InfoItemTitle>
    //                                 <InfoItemValue>
    //                                     {formatNumber(line.markingCodesCount)}
    //                                 </InfoItemValue>
    //                             </InfoItem>
    //                             <InfoItem>
    //                                 <InfoItemTitle>
    //                                     {t('pages.profile.equipment.products')}
    //                                 </InfoItemTitle>
    //                                 <InfoItemValue>{formatNumber(line.goodsCount)}</InfoItemValue>
    //                             </InfoItem>
    //                             <InfoItem>
    //                                 <InfoItemTitle>
    //                                     {t('pages.profile.equipment.defect')}
    //                                 </InfoItemTitle>
    //                                 <InfoItemValue>{line.defectPercentage}%</InfoItemValue>
    //                             </InfoItem>
    //                         </InfoContainer>
    //                     </StatisticsContainer>
    //                     <ActivityContainer>
    //                         <ActivityTitle>{t('pages.profile.equipment.activity')}</ActivityTitle>
    //                         <ActivityContent>
    //                             {line.activity.map((item, index) => (
    //                                 <ActivityContentItem key={index}>
    //                                     <span>{formatDate(item.timestamp, 'dd.MM.yyyy')}</span>
    //                                     <span>
    //                                         {item.active
    //                                             ? t('pages.profile.equipment.active')
    //                                             : t('pages.profile.equipment.notActive')}
    //                                     </span>
    //                                 </ActivityContentItem>
    //                             ))}
    //                         </ActivityContent>
    //                     </ActivityContainer>
    //                 </ContentWrapper>
    //             )}
    //         </ContentContainer>
    //     </Page>
    // );
};
